import { db, functions } from '.';

async function addOrdersToDB(orders) {
  await db.runTransaction(async transaction => {
    await Promise.all(
      orders.map(async ({ user, ...docData }) => {
        const newOrderRef = db.collection('orders').doc();
        docData.user = db.collection('users').doc(user.id);
        await transaction.set(newOrderRef, docData);
      })
    );
  });
}

/**
 * @param {String} ordersData - orders to create
 */
async function addOrders(ordersData) {
  const createOrderCall = functions.httpsCallable('adminOrdersCreate');
  await createOrderCall(ordersData);
}

async function getOrderFromDB(id) {
  const ref = db.collection('orders').doc(id);
  const snapshot = await ref.get();
  return {
    id,
    ...snapshot.data()
  };
}

// NOTE: Unlike the other firebase modules, in this module `add` function
// expects multiple order list and all of which will the added to the server.
// This can be better implemented by supporting it in the `canAdd` plugin itself
// but since there are no other module that needs to add more than one record at
// a time as of now. implementing that at a plugin level is an overkill.
export default {
  add: addOrders,
  get: getOrderFromDB
};
